<script setup lang="ts">
import { defineProps } from 'vue'

const props = defineProps<{
  imageUrl: string
  size: 'small' | 'medium'
}>()

const size = computed(() => {
  return props.size === 'small' ? '42px' : '168px'
})

</script>

<template>
  <img
    :src="props.imageUrl"
    alt="City Image"
    class="rounded-lg"
    :height="size"
    :width="size"
    :style="{ objectFit: 'cover' }"
  >
</template>
